export default "__VITE_PUBLIC_ASSET__6cb497ba__"